module.exports = __webpack_public_path__ + "img/mono_28.b55cfafe.png";